import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Skeleton from './loaders/Skeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormField',
  props: {
    label: null,
    labelWidth: null,
    optional: null,
    big: { type: Boolean },
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  label?: string,
  labelWidth?: number | string,
  optional?: string,
  big?: boolean,
  loading?: boolean,
};



const labelWidthValue = computed(() => props.labelWidth ? ((typeof props.labelWidth === 'number') ? props.labelWidth + 'px' : props.labelWidth) : undefined);


return { __sfc: true,props, labelWidthValue, Skeleton }
}

})